import { useFormContext } from 'react-hook-form';

import type { InventoryFormSchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';

export const useInventoryFormContext = () => {
  const context = useFormContext<InventoryFormSchema>();
  return context;
};
